import {
  useAddVoteArticleMutation, useDeleteVoteArticleMutation,
} from 'rtkQuery/sharespro/queries/articles';

const useSetPollAnswer = (
  articleId: ID,
  pollId: ID,
  page: number
): (answerId: number | null) => void => {
  const [addVote] = useAddVoteArticleMutation();
  const [deleteVote] = useDeleteVoteArticleMutation();

  return (answerId: number | null) => {
    if (answerId !== null) {
      addVote({ article_id: articleId, page, poll_id: pollId, answer_id: answerId });
    } else {
      deleteVote({ article_id: articleId, page, poll_id: pollId, answer_id: null });
    }
  };
};

export default useSetPollAnswer;
